import React, { useState } from 'react'
import { SportsbookCheckbox } from 'components/ui'

/**
 * Designed to be used witn a FORMIK FIELD
 * A select field where all the options are checkboxes and the user may choose an option
 * options should be an array of objects that all have the shape { value, label }
 * where value is the value set for the formik field name on selection, and label is the prompt next
 * to the checkbox
 *
 * @param {Object} param0
 */
const SelectChecklist = ({ name, options = [], setFieldValue, onChange }) => {
  const [selected, setSelected] = useState(null)
  const handleClick = (value) => {
    if (selected === value) {
      setSelected(null)
      setFieldValue(name, '')
      onChange('')
    } else {
      setSelected(value)
      setFieldValue(name, value)
      onChange(value)
    }
  }
  return (
    <>
      <div className='selectCheckContainer'>
        {options.map(({ value, label }, idx) => (
          <SportsbookCheckbox
            id={value}
            value={value}
            name={value}
            label={label}
            key={idx}
            checked={selected === value}
            onClick={() => handleClick(value)}
            readOnly
          />
        ))}
      </div>
      <style jsx>{`
        .selectCheckContainer {
          display: block;
          position: relative;
        }
      `}</style>
    </>
  )
}

export default SelectChecklist
